import { useSelector } from "react-redux";

import "./index.css";
import { Toast } from "@wish-ui";

const VARIANT_MAP = {
  success: "positive",
  error: "negative",
  info: "neutral",
  "add-to-cart": "neutral",
  "add-to-wishlist": "neutral",
  "remove-from-wishlist": "neutral",
};

const ICON_MAP = {
  error: "fa-solid fa-exclamation-circle",
  info: "fa-solid fa-info-circle",
  "add-to-cart": "fa-solid fa-cart-plus",
  "add-to-wishlist": "fa-solid fa-heart",
  "remove-from-wishlist": "fa-regular fa-heart",
};

const WishlinkNotification = () => {
  const { showToast, variant, message } = useSelector(
    (state) => state.notificationReducer
  );

  return (
    <>
      {showToast && (
        <Toast
          key={Date.now()}
          message={message}
          type={VARIANT_MAP[variant] || "neutral"}
          action="icon"
          icon={ICON_MAP[variant] || ""}
          // onClick={() => setIsVisible(false)} // Hide toast when clicked
        />
      )}
    </>
  );
};

export default WishlinkNotification;
